export enum ChainAsset {
  QCAD = 'QCAD'
}

export enum StagingChainAsset {
  QCAD_TEST = 'QCAD_TEST'
}
